import { KeyValueObject } from '../core/KeyValueObject';

export class MerchantLookupItem extends KeyValueObject {
    contragentId: number;
    contragentName: string;
}